import { getFunctions, httpsCallable } from 'firebase/functions'
import { initializeApp, getApp, getApps } from 'firebase/app'
import { isQaSession } from './qa'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyC9lSvdpQKR1XEsDKQ9mc6EfjaVjkZYreU',
  authDomain: 'kidneyrecipes.firebaseapp.com',
  projectId: 'kidneyrecipes',
  storageBucket: 'kidneyrecipes.firebasestorage.app',
  messagingSenderId: '810820724974',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:810820724974:web:4f3cd0fdb33b892f83abff',
}

// Reuse existing app or initialize
const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
const functions = getFunctions(app)

const createContactFn = httpsCallable(functions, 'loopsCreateContact')
const purchaseCompletedFn = httpsCallable(functions, 'loopsPurchaseCompleted')

interface ContactData {
  email: string
  source?: string
  kidneyStatus?: string
  primaryGoal?: string
  weightKg?: number
  sodiumLimit?: number
  potassiumLimit?: number
  phosphorusLimit?: number
  proteinLimit?: number
  fluidLimitMl?: number
  marketingConsent?: boolean
}

/**
 * Create or update a contact in Loops when user submits their email.
 * Proxied through Cloud Function to avoid CORS.
 */
export async function createLoopsContact(data: ContactData) {
  // QA sessions never touch Loops (plan §A5).
  if (isQaSession()) return
  try {
    await createContactFn(data)
  } catch (err) {
    console.error('Loops create contact error:', err)
  }
}

/**
 * Send purchase completed event to stop the abandoned cart sequence.
 */
export async function loopsPurchaseCompleted(email: string, plan: string, transactionId: string) {
  if (isQaSession()) return
  try {
    await purchaseCompletedFn({ email, plan, transactionId })
  } catch (err) {
    console.error('Loops purchase completed error:', err)
  }
}
